import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { expandJSON } from "src/helpers/helper";
import { AET_DASHBOARD_SUMMARY } from "src/redux/config/links";

const FleetCarbon = ({ fleet }) => {
  const [loadSummary, setLoadSummary] = useState(true);
  const [data, setData] = useState(null);

  const { authStore } = useSelector((state) => ({
    authStore: state.authStore,
  }));

  const onGetSummary = useCallback(
    ({ page, sort, filter={}, show = [], groupby = [] }) => {
      //   setLoadingCompany(true);
      let newFilter = {};
      Object.keys(filter).forEach((item) => {
        newFilter = { ...newFilter, [item]: encodeURI(`%${filter[item]}%`) };
      });

      const query = expandJSON({ page, sort, filter: newFilter, show, groupby })
        .map((item) => `${item.label}=${item.value}`)
        .join("&");
      axios({
        url: `${AET_DASHBOARD_SUMMARY}?${query}`,
        method: "POST",
        headers: {
          Authorization: authStore.authData.result.token,
        },
      })
        .then((result) => {
          //   setLoadingCompany(false);
          setData(result.data);
        })
        .catch(() => {
          //   setLoadingCompany(false);
        });
    },
    [authStore.authData.result.token]
  );

  useEffect(() => {
    if (loadSummary) {
      setLoadSummary(false);
      onGetSummary({
        ...(fleet === "All"
          ? {}
          : {
              filter: {
                leftJoin_fleet_reg_number: fleet,
              },
            }),
      });
    }
  }, [loadSummary, onGetSummary, setLoadSummary, fleet]);
  return (
    <>
      {!!data ? (
        <>
          ({(!!data ? data.result.carbon_total.total : 0).toFixed(2)} tCO2e{" "}
          {!!data
            ? data.result.carbon_total.calculated_do !==
              data.result.carbon_total.total_do
              ? `(${data.result.carbon_total.calculated_do} of ${data.result.carbon_total.total_do} calculated)`
              : null
            : null}
          )
        </>
      ) : null}
    </>
  );
};
export default FleetCarbon;
